module.exports = __webpack_public_path__ + "static/media/arrows.44ab4883.svg";